Greenmile.Components.ChangePasswordModal = (function () {
    return function (entity) {

        this.formModal = new Monet.Form.Modal("#templates_container", { width: 303, height: 310 }, null, "#page_container");
        this.entity = entity

    	this.changePassword = {
            loginField: {
                value: null,
                disabled: false
            },
            errorDiv: {
                text: null,
            },
            sendNewPassword: null,
            onChangePassword: null,
            createPasswordValidator: false,
            hideCurrentField: false
        };

    	this.show = (function () {
    		const changePassword = new Greenmile.Components.ChangePassword(entity);
    		this.formModal.showModalForm();
    		var modal = document.querySelector(".popupFormContainer");
    		modal.classList.add("changePasswordModal");

    		changePassword.init(modal);
            if (changePassword.contentDiv) {
                changePassword.loginField.value = this.changePassword.loginField.value;
                changePassword.loginField.disabled = this.changePassword.loginField.disabled;
                changePassword.errorDiv.innerHTML = this.changePassword.errorDiv.text;
                changePassword.onChangePassword = this.changePassword.onChangePassword;
                changePassword.cancelBtn.addEventListener('click', this.hide);

                if (this.changePassword.sendNewPassword) {
                    changePassword.sendNewPassword = this.changePassword.sendNewPassword.bind(changePassword);
                }

                if (this.changePassword.createPasswordValidator) {
                    changePassword.createPasswordValidator();
                }

                if (this.changePassword.hideCurrentField) {
                    changePassword.hideCurrentField();
                }
            }

    	}).bind(this);

    	this.hide = (function () {
    		this.formModal.closeModalWindow();
    	}).bind(this);

        return this;
    };
}());